var ApiRoute;
(function(ApiRoute) {
    ApiRoute["AskUsAnything"] = "/_mrkt/contact_us";
    ApiRoute["PrivacyBannerAcceptCookies"] = "/_mrkt/privacy/accept_cookies";
    ApiRoute["PrivacyBannerTrackImpression"] = "/_mrkt/privacy/cookies_banner_shown";
    ApiRoute["UpdateLocale"] = "/_mrkt/locale";
})(ApiRoute || (ApiRoute = {}));

export { ApiRoute };
